exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select[data-v-4a4e50a6]{-webkit-transform:translateY(-3px);transform:translateY(-3px)}\n", ""]);

// exports
